/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";

interface InputFieldProps {
  type: string;
  handleInputChange: (event: any) => void;
  handleInputclick?: (event: any) => void;
  className: string;
  placeHolder: string;
  name?: string;
  inputValue?: any;
  errorMsg?: string;
  isError?: boolean;
  inputLabel?: string;
  autoFocusOnInput?: boolean;
  maxLength?: number;
  readOnly?: boolean;
  isInputDisable?: boolean
}

/**
 * Reusable React component - Input Field.
 *
 * @namespace InputField
 */

class InputField extends React.Component<InputFieldProps> {
  constructor(props: InputFieldProps) {
    super(props);

    this.state = {};
  }

  /**
   * This method is used for handle input change
   * @param {any} e
   *
   */
  handleInputChange = (e: any) => {
    if (this.props.handleInputChange) {
      if (this.props.maxLength) {
        if (isNaN(Number(e.target.value))) {
          return;
        } else {
          this.props.handleInputChange(e);
        }
      } else {
        this.props.handleInputChange(e);
      }
    }
  };

  render() {
    const {
      className,
      placeHolder,
      type,
      inputValue,
      errorMsg,
      isError,
      name,
      inputLabel,
      autoFocusOnInput,
      maxLength,
      readOnly,
      isInputDisable
    } = this.props;
    return (
      <div
        className={isError ? "input-wrapper error-wrapper" : "input-wrapper"}
      >
        <div className={inputLabel ? "input-label" : "hide"}>{inputLabel}</div>
        <div className="custom-input-wrapper">
          <input
            type={type}
            name={name}
            placeholder={placeHolder}
            className={className}
            value={inputValue || ""}
            onChange={this.handleInputChange}
            onClick={(e) =>
              this.props.handleInputclick && this.props.handleInputclick(e)
            }
            autoFocus={autoFocusOnInput || false}
            maxLength={maxLength && maxLength}
            readOnly={readOnly || false}
            disabled={isInputDisable}
          />

          <span className="icon error-info"></span>
        </div>
        <div tabIndex={0} className={isError ? "error-msg" : "hide"}>
          {errorMsg}
        </div>
      </div>
    );
  }
}

export default InputField;
